<template>
  <div class="aboutUs">
    <heads></heads>
    <div class="container">
      <div>
        <div class="title">关于我们</div>
        <div class="content" v-html="content.companyIntroduction" v-loading="loading"></div>
      </div>
    </div>
    <homeFoots></homeFoots>

    <!-- <foots></foots> -->
  </div>
  <!-- articalDetail end -->
</template>

<script>
import heads from "@/components/comment/heads.vue";
import banners from "@/components/comment/banners.vue";
import foots from "@/components/comment/foots.vue";
import homeFoots from "@/components/comment/homeFoots.vue";

import axios from "axios";
import qs from "qs";
export default {
  name: "articalDetail",
  data() {
    return {
      content:'',
      loading:false
    };
  },
  components: {
    heads,
    foots,
    banners,
    homeFoots
  },
  computed: {},
  methods: {
    getInfo() {
      axios
        .get(`/mobile/cmWebBasicConfig/getCmWebBasicConfigById.jhtml`)
        .then(res => {
          if (res.data.success) {
            this.content = res.data.output;
          } else {
            this.$message("系统繁忙，请稍后再试~");
          }
          this.loading = false;
        });
    }
  },
  mounted() {
    this.loading = true;
    this.getInfo()
  }
};
</script>

<style scoped>
.articalDetail {
  display: flex;
  flex-flow: column;
  min-height: 100vh;
  overflow: auto;
  /* background: #f5f5f5; */
  background-image: linear-gradient(to bottom, #c4dafc, #f3f7ff);
}
.container {
  flex: 1;
  position: relative;
  /* background: #fff; */
  margin: 30px auto;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);
  padding: 0 30px;
}
.title {
  margin-top: 20px;
  line-height: 35px;
  font-size: 18px;
}
.info {
  color: #999;
  font-size: 12px;
}

.info span {
  margin: 0 8px;
}
.green {
  margin: 0;
  color: rgb(44, 211, 44);
}
.content {
  margin-top: 20px;
  text-align: left;
  font-size: 14px;
  margin-bottom: 50px;
  min-height: 300px;
  color: #000;
}
.btn-wrapper {
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-bottom: 10px;
}
.btn {
  width: 120px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#628cef),
    to(#1e81d6)
  );
  background-image: -webkit-linear-gradient(left, #628cef, #1e81d6);
  background-image: -moz- oldlinear-gradient(left, #628cef, #1e81d6);
  background-image: linear-gradient(to right, #628cef, #1e81d6);
  color: #fff;
  font-size: 14px;
  margin-right: 10px;
  margin-top: 5px;
  display: inline-block;
  cursor: pointer;
}
.btn:hover {
  background: #1e81d6;
}
.btn i {
  margin-right: 5px;
}

.active {
  color: #1e81d6;
}
.file-wrapper {
  position: relative;
}
.file-title {
  text-align: right;
  margin: 10px;
  color: #1e81d6;
}
.dwbtn {
  width: 120px;
  height: 30px;
  line-height: 30px;
  border-radius: 30px;
  text-align: center;
  background: #1e81d6;
  color: #fff;
  font-size: 14px;
  margin-right: 10px;
  margin-top: 5px;
  display: inline-block;
  float: right;
  margin-bottom: 20px;
  cursor: pointer;
}
.dwbtn i {
  margin-right: 5px;
}
</style>
<style>
@media screen and (max-width: 767px) {
  .el-dialog {
    width: 80% !important;
  }
} /* @media only screen and (max-width: 767px) */
</style>




// WEBPACK FOOTER //
// src/components/aboutUs.vue